/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum States {
  Unpaid = 'Unpaid',
  Paid = 'Paid',
  Expired = 'Expired'
}
